<template>
  <div class="reset">

    <!-- [ Wrapper content ] start -->
    <div class="wrapper">
      <!-- [Select language] start -->
      <SelectLanguage/>
      <!-- [Select language] end -->
      <!-- [ Header form ] start -->
      <Header icon="envelope"/>
      <!-- [ Header form ] end -->

      <!-- [ Title form ] start -->
      <Title :title="$t('auth_title_reset_password')"/>
      <!-- [ Title form ] end -->

      <!-- [ Reset form ] start -->
      <el-row  :gutter="20" type="flex" justify="center">
        <el-col :span="24">
          <el-form @submit.prevent.native="submitForm('form')" :model="form" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">

            <el-form-item prop="email">
              <el-input v-model="form.email" :label="$t('auth_form_email')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="width-100" @click="submitForm('form')">{{$t('auth_btn_reset_password')}}</el-button>
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <!-- [ Reset form ] end -->

      <!-- [ Footer form ] start -->
      <el-row :gutter="20" type="flex" justify="center" class="row-padding footer__link">
        <el-col :span="24">
          <div>
            {{$t('auth_try_free')}}
            <router-link to="/signup">{{$t('auth_signup')}}</router-link>
          </div>
          <div>
            {{$t('auth_back_to_login')}}
            <router-link to="/login">{{$t('auth_login')}}</router-link>
          </div>
        </el-col>
      </el-row>
      <!-- [ Footer form ] end -->
    </div>
    <!-- [ Wrapper content ] end -->

  </div>
</template>

<script>
import SelectLanguage from '@/components/SelectLanguage.vue'
import Header from '@/components/auth/Header.vue'
import Title from '@/components/auth/Title.vue'
import axios from 'axios'
  export default {
  name: 'reset',
    components: {
      SelectLanguage,
      Header,
      Title
    },
    data() {
      return {
        loading: false,
        form: {
          email: '',
        },
        rules: {
          email: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post('/api/v1/auth/resetPassword', {
                email: this.form.email,
                type: 'dev'
              })
              .then(response => {
                // Handle success.
                console.log('Your user received an email');
                console.log('---', response.data);
                this.notification("Success", "Please check your email and follow reset steps", "success")

                this.$router.push('/login');
                loader.hide()
              })
              .catch(error => {
                // Handle error.
                console.log('An error occurred:', error);
                this.notification("Notification", error.response.data.message, "info")
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
.reset {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;
    background: linear-gradient(0deg,#29b996,#3498db);
    background-size: 400% 400%;
    animation: backgroundGradient 10s ease infinite;

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    @keyframes backgroundGradient {
      0% {
        background-position: 0 0;
      }

      50% {
        background-position: 0 100%;
      }

      100% {
        background-position: 0 0;
      }
    }

  .wrapper {
    box-sizing: border-box;
    max-width: 350px;
    padding: 40px 35px;
    background: #ffffff;
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
    position:relative;
  }
  .text-align-left {
    text-align: left;
  }
  .width-100 {
    width: 100%;
  }
  .mb {
  margin-bottom: 20px;
  }
}

.footer__link {
  line-height: 1.6;
  color: #909399;
}

.row-padding {
  padding: 10px 0;
}
</style>
